import { createType, genFetchEpic } from '../common/util';
import { OPERATION_ANALYT, DATA } from '../common/dict';
import { operationInsightUri } from '../actions/api';

const operation = genFetchEpic(createType(OPERATION_ANALYT, DATA), operationInsightUri);

export default operation;
